import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import AddAddressComponent from 'components/IncomingEmails/AddAddress'
import {
  CardModalView,
  ViewBody
} from 'components/Sidebar'

export class AddAddress extends React.Component {
  static propTypes = {
    cardId: PropTypes.number.isRequired,

    incomingMailsDomain: PropTypes.string.isRequired,

    requestAddIncomingMail: PropTypes.func.isRequired
  }

  handleCreatePublicAddress = ({ name, validateAddress }) => {
    return this.props.requestAddIncomingMail({
      cardId: this.props.cardId,
      name,
      validateAddress,
    })
  }

  render () {
    const {
      incomingMailsDomain
    } = this.props

    return (
      <CardModalView
        title={<FormattedMessage id='INCOMING_EMAILS_ADD_TITLE' />}
      >
        <ViewBody>
          <AddAddressComponent
            incomingMailsDomain={incomingMailsDomain}
            onCreatePublicAddress={this.handleCreatePublicAddress}
          />
        </ViewBody>
      </CardModalView>
    )
  }
}

export default AddAddress
